import { Component, input } from '@angular/core';
import { NgClass } from '@angular/common';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { ToggleLabelSwitchComponent } from '../toggle-label-switch/toggle-label-switch.component';

@Component({
  selector: 'app-toggle-switch',
  imports: [NgClass, NgbTooltip],
  template: `
    <div class="row form-switch-wrapper align-items-center mb-0">
      @if (!hideIcon()) {
        <div class="col-auto switch-icon pe-1">
          <i
            [class]="iconClass()"
            [ngClass]="currentValue() ? '' : 'text-muted'"></i>
        </div>
      }
      <div class="col-auto">
        <div class="form-check form-switch {{ class() }}">
          <input
            class="form-check-input"
            (change)="onToggleSwitch()"
            [checked]="currentValue()"
            [disabled]="disabled()"
            type="checkbox"
            [attr.aria-label]="id()"
            #toggleSwitch
            [id]="id()" />
          @if (!hideLabel()) {
            <label
              class="form-check-label"
              [for]="id()">
              {{ label() }}
            </label>
          }
        </div>
      </div>
      @if (showTooltip()) {
        <div class="col-auto ps-0">
          <i
            class="iconoir-info-circle text-muted"
            [ngbTooltip]="tooltipText()"
            tooltipClass="custom-tooltip"></i>
        </div>
      }
    </div>
  `,
})
export class ToggleSwitchComponent extends ToggleLabelSwitchComponent {
  hideIcon = input<boolean>(false);
  hideLabel = input<boolean>(false);
  textLeft = input<boolean>(false);
  class = input<string>('');
}
